<script setup>
import { useRoute } from "vue-router";
import { onMounted, ref } from "vue";
import { useAcademyStore } from "@/stores";

const route = useRoute();

const academyStore = useAcademyStore();

const evaluation = ref({})

onMounted(async () => {
  const response = await academyStore.getStudentEvaluation({id: route.params.id});
  evaluation.value = response.data
})
</script>

<template>
  <div
    v-if="Object.keys(evaluation).length > 0"
    class="pa-5"
  >
    <div class="d-flex align-center justify-start ">
      <div>
        <h1>{{ evaluation.studentEvaluationId }}</h1>
      </div>
    </div>
    <v-divider />
    <div class="d-flex box-holder">
      <div class="d-flex box-row flex-1-0-0">
        <div class="box-container mt-5">
          <h3 class="pa-2 text-white">
            <v-icon>mdi-briefcase</v-icon> Evaluation Data
          </h3>
          <div
            v-if="evaluation.beneficiaryId"
            class="info pa-2"
          >
            <div class="label mb-1">
              Beneficiary
            </div>
            <div class="answer">
              <router-link
                :to="'/beneficiary/intake/view/' + evaluation.beneficiaryId"
                target="_blank"
                class="chip-link-color"
              >
                <v-chip> {{ evaluation.beneficiaryName }} </v-chip>
              </router-link>
            </div>
          </div>

          <div
            v-if="evaluation.tutor"
            class="info pa-2"
          >
            <div class="label mb-1">
              Tutor
            </div>
            <div class="answer">
              {{ evaluation.tutor }}
            </div>
          </div>

          <div
            v-if="evaluation.course"
            class="info pa-2"
          >
            <div class="label mb-1">
              Course
            </div>
            <div class="answer">
              <router-link
                :to="'/academy/view/' + evaluation.course.id"
                target="_blank"
                class="chip-link-color-academy"
              >
                <v-chip> {{ evaluation.course.cycle }} </v-chip>
              </router-link>
            </div>
          </div>
          <div
            v-for="answer in evaluation.answers"
            :key="answer.id"
            class="info pa-2"
          >
            <div class="label mb-1">
              {{ answer.question }}
            </div>
            <div v-if="answer.questionType === 'SCALE' && answer.option != null && answer.option != ''">
              <v-rating
                v-model="answer.option"
                color="academy"
                full-icon="mdi-circle"
                empty-icon="mdi-circle-outline"
                :length="answer.numOfOptions"
                readonly
              />
            </div>
            <div v-else-if="answer.questionType === 'TEXT' && answer.comment != null && answer.comment != ''">
              <span v-html="answer.comment" />
            </div>
            <div v-else>
              -
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
h1 {
  font-size: 48px;
  color: rgb(var(--v-theme-academy));
}
.box-holder {
  gap: 20px;
  .box-row {
    flex-direction: column;
    .box-w3 {
      width: 100%;
    }
    .box-container {
      border: 1px solid rgb(var(--v-theme-academy));
      h3 {
        background-color: rgb(var(--v-theme-academy));
        color: black;
      }
      .info {
        .label {
          text-decoration: underline;
        }
        .answer {
          display: block;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
